import { useTheme } from '@emotion/react';
import type { WeaveTheme } from '@frontend/theme';
import type { WeaveTheme as OriginalTheme } from '@frontend/theme-original';

export const useThemeValues = useTheme as unknown as () => WeaveTheme | OriginalTheme;
